import {Banner} from '@primer/react'
import {sendEvent} from '@github-ui/hydro-analytics'
import {useSessionContext} from '../../contexts/SessionContext'
import {useAgentInfo} from '@github-ui/copilot-shared-ui/agents/use-agent-info'
import {renderTextWithLinks} from '../../utils/render-text-with-links'

interface SessionFailedBannerProps {
  errorMessage: string | null
  workflowRunLink: string | null
}

export function SessionFailedBanner({errorMessage, workflowRunLink}: SessionFailedBannerProps) {
  const {session} = useSessionContext()
  const {data: agentInfo} = useAgentInfo(session.agent_id, session.agent_slug)
  const defaultErrorMessage = 'An unexpected error occurred. For more details, see the detailed logs in GitHub Actions.'
  const sessionFailedError = errorMessage || defaultErrorMessage
  const handleDetailedLogsClick = () => {
    sendEvent('agent_sessions.task_view', {
      target: 'CLICK_SESSION_ERROR_LOGS_LINK',
      session_id: session.id,
      task_id: session.resource_global_id,
    })
  }

  return (
    <Banner
      aria-label="Session error"
      title={`${agentInfo?.display_name || 'Agent'} stopped work due to an error`}
      description={renderTextWithLinks(sessionFailedError)}
      variant="critical"
      actionsLayout="stacked"
      primaryAction={
        workflowRunLink && (
          <Banner.PrimaryAction as="a" href={workflowRunLink} onClick={handleDetailedLogsClick}>
            View run
          </Banner.PrimaryAction>
        )
      }
    />
  )
}
